// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/select_arow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/ongoing.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/sold.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 
scss
 */
/* 
Body Theme Color
 */
/* 
Dark Theme Colors
*/
/* 
Button Theme
*/
/* 
Max Dashboard scss
*/
/* 
Min Dashboard scss
*/
/* 
Max Dashboard scss
*/
.EventCustomTable_dashboard__3q6ll {
  width: calc(100% - 320px);
  position: relative;
  left: 290px;
  padding: 30px;
  border-radius: 8px;
  min-height: auto !important;
  background-color: #F5F6FA;
  overflow-y: auto;
  padding-right: 0px;
}

.EventCustomTable_dashboardContain__XQ\\+IO {
  width: calc(100% - 320px);
  background-Color: #F5F6FA;
  border-radius: 8px;
}

.EventCustomTable_bodythemedark__qLtQS .EventCustomTable_dashboardContain__XQ\\+IO,
.EventCustomTable_bodythemedark__qLtQS .EventCustomTable_dashboard__3q6ll,
.EventCustomTable_bodythemedark__qLtQS .EventCustomTable_cont2__Brv3d {
  background-Color: #0f1824;
}

.EventCustomTable_top_header__gBuaB .EventCustomTable_top_header_inner__Srb3z {
  background-color: transparent;
  height: auto;
  overflow-y: unset;
}

/* 
Min Dashboard scss
*/
.EventCustomTable_cont2__Brv3d {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 30px;
  border-radius: 8px;
  background: #F5F6FA;
  /*height: calc(100vh - 160px);*/
  height: 100%;
  min-height: auto !important;
  /* 
  background-Color: \$dashboardbackgroundColor;
    padding-bottom: 8%;
  */
}

.EventCustomTable_subLink__mXaME svg {
  position: relative;
  top: -2px;
  left: -7px;
}

.EventCustomTable_cst_vendr__4-B7R input {
  min-height: 35px !important;
}

.EventCustomTable_cst_vendr__4-B7R .EventCustomTable_form-control__OVMIQ {
  background-color: #f5f6fa;
  border: none;
}

.EventCustomTable_footer__d3Hdv {
  height: 70px;
}

body {
  background-color: #fff;
}

/* 
THEME CHANGE
*/
.EventCustomTable_bodythemelight__DjJjM {
  background-color: #fff;
  padding-top: 90px;
}

.EventCustomTable_bodythemedark__qLtQS {
  background-color: #132337;
  padding-top: 90px;
}

.EventCustomTable_bodythemeNew__Mx1tO {
  background-color: #f5f6fa;
}

/* 
Header Navbar Theme
*/
.EventCustomTable_headerthemelight__-F6ud {
  background-color: #fff;
}

.EventCustomTable_headerthemedark__k1vRs {
  background-color: #132337;
}

.EventCustomTable_top_header__gBuaB {
  min-height: 90px;
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 2;
  top: 0;
}

/* 
LEFT MENU THEME CHANGE
*/
.EventCustomTable_menuthemelight__iXOHs {
  background-color: #f5f6fa;
}

.EventCustomTable_menuthemedark__05uNh {
  background-color: #132337;
}

/* 
LEFT MENU LINKS THEME CHANGE
*/
.EventCustomTable_menulinklight__yRckC span {
  color: #666666 !important;
}

.EventCustomTable_menulinklight__yRckC a {
  color: #CBCBCB !important;
}

.EventCustomTable_menulinklight__yRckC:hover span,
.EventCustomTable_menulinklight__yRckC:hover a {
  color: #fff !important;
}

.EventCustomTable_menulinkdarkSelected__FteB6 {
  background-color: #1c2e45;
  color: #3b82f6;
}

.EventCustomTable_menuthemelight__iXOHs .EventCustomTable_menulinklightSelected__U8a5W {
  /*background-color: \$lightthemecolor;*/
  color: #fff !important;
  background-color: #131F43 !important;
}

.EventCustomTable_menulinkdark__p4O4v {
  color: #92afd3 !important;
}

.EventCustomTable_menulinklight__yRckC:hover {
  color: #fff !important;
  background-color: #131F43 !important;
}

.EventCustomTable_menulinklight__yRckC .EventCustomTable_sub_arrow__ZGx5\\+ svg path {
  stroke: #CBCBCB !important;
}

.EventCustomTable_menulinklight__yRckC:hover .EventCustomTable_sub_arrow__ZGx5\\+ svg path {
  stroke: #fff !important;
}

.EventCustomTable_menulinkdark__p4O4v .EventCustomTable_sub_arrow__ZGx5\\+ svg path {
  stroke: #92afd3 !important;
}

.EventCustomTable_menulinkdark__p4O4v:hover .EventCustomTable_sub_arrow__ZGx5\\+ svg path {
  stroke: #fff !important;
}

.EventCustomTable_menulinklight__yRckC:hover svg path,
.EventCustomTable_menulinklightSelected__U8a5W svg path {
  fill: #fff !important;
}

.EventCustomTable_menulinkdark__p4O4v:hover {
  background-color: #1c2e45;
  color: #fff;
}

/* 
BODY HEADERS
*/
.EventCustomTable_headinglight__yr13r {
  color: #60677e;
}

.EventCustomTable_headingdark__0WCp8 {
  color: #60677e;
}

/* 
SEARCH BOX THEME COLOR
*/
.EventCustomTable_searchboxlight__7KGVy {
  background-color: #fff;
  border: none;
}

.EventCustomTable_searchboxdark__N4Jdf {
  background-color: #132337;
  color: #fff;
  border: none;
}

.EventCustomTable_searchboxdark__N4Jdf::placeholder {
  color: #60677e;
}

/* 
CUSTOM TABLE THEME COLOR
*/
.EventCustomTable_tableheadlight__WYBfi {
  background-color: #131F43;
  border-radius: 5px 5px 0px 0px;
}

.EventCustomTable_tableheadlight__WYBfi th {
  color: #fff;
}

thead .EventCustomTable_tableheadlight__WYBfi th:first-child,
thead .EventCustomTable_tableheaddark__8fZUF th:first-child {
  border-radius: 5px 0 0 0px;
}

thead .EventCustomTable_tableheadlight__WYBfi th:last-child,
thead .EventCustomTable_tableheaddark__8fZUF th:last-child {
  border-radius: 0 5px 0px 0;
}

th:first-child {
  border-radius: 0px;
}

td:last-child {
  border-radius: 0px;
}

table.EventCustomTable_table__D4D3z.EventCustomTable_table-borderless__W3epF {
  border-collapse: separate !important;
  border-spacing: 0 0px !important;
}

.EventCustomTable_tableheaddark__8fZUF {
  background-color: #132337;
  color: #fff;
}

.EventCustomTable_table-borderless__W3epF tr:nth-child(even) {
  background-color: #F9FAFB;
}

.EventCustomTable_table-borderless__W3epF .EventCustomTable_left-section__EJ9TT {
  padding-top: 10px;
}

.EventCustomTable_tablebodylight__KU-2a td,
.EventCustomTable_tablebodydark__pGqng td {
  padding: 0.5rem 1rem !important;
  line-height: 45px;
}

.EventCustomTable_tablebodylight__KU-2a {
  background-color: #fff;
}
.EventCustomTable_tablebodylight__KU-2a:hover {
  background-color: #fff;
  cursor: auto;
}
.EventCustomTable_tablebodylight__KU-2a p {
  line-height: 24px;
}

.EventCustomTable_tablebodydark__pGqng {
  /* background-color: \$primarydark-color; */
  color: #60677e;
}
.EventCustomTable_tablebodydark__pGqng:hover {
  background-color: rgba(33, 150, 243, 0.1);
  cursor: pointer;
}

/* 
PAGINATION THEME COLOR
*/
.EventCustomTable_paginationlight__ela15 {
  color: #60677e !important;
  font-size: 13px !important;
}

.EventCustomTable_paginationdark__VhRt0 {
  color: #60677e !important;
  font-size: 13px !important;
}

/* 
SETTING FORM THEME COLOR
*/
.EventCustomTable_formthemelight__jFUCP {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.EventCustomTable_formthemedark__pMIn4 {
  background-color: #132337;
  color: #60677e !important;
  font-size: 14px;
}
.EventCustomTable_formthemedark__pMIn4 ::placeholder {
  color: #60677e;
}

/* 
VIEW FORM DETAILS BOX THEME COLOR
*/
.EventCustomTable_viewformlight__iogzo {
  background-color: #f3f6f9;
}

.EventCustomTable_permissionboxlight__dq1JN {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.EventCustomTable_permissionboxdark__X-qMv {
  background-color: #0f1824;
  border: solid 1px #242434;
}

.EventCustomTable_errormsgclr__HsOHG {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

/* 
Graph theme
*/
.EventCustomTable_graphclrlight__DdTSP {
  background-color: #fff;
}

.EventCustomTable_graphclrdark__ns0wM {
  background-color: #132337;
}

/* 
Counter theme
*/
#EventCustomTable_card1bglight__sy6pB {
  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */
  background-color: #fff;
}

#EventCustomTable_card1bgdark__p5W0d {
  background: #392f28;
}

#EventCustomTable_card2bglight__GwGNN {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #fff;
}

#EventCustomTable_card2bgdark__i3MmW {
  background: #1c3238;
}

#EventCustomTable_card3bglight__fB6cC {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #fff;
}

#EventCustomTable_card3bgdark__l6dKJ {
  background: #3a2434;
}

#EventCustomTable_card4bglight__yjmoi {
  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */
  background-color: #fff;
}

#EventCustomTable_card4bgdark__hOgkz {
  background: #2f264f;
}

#EventCustomTable_card1bgdark__p5W0d a,
#EventCustomTable_card1bgdark__p5W0d p,
#EventCustomTable_card2bgdark__i3MmW a,
#EventCustomTable_card2bgdark__i3MmW p,
#EventCustomTable_card3bgdark__l6dKJ a,
#EventCustomTable_card3bgdark__l6dKJ p,
#EventCustomTable_card4bgdark__hOgkz a,
#EventCustomTable_card4bgdark__hOgkz p {
  color: #fff;
}

/* 
Action button theme
*/
.EventCustomTable_actionbtnlight__GMAzQ {
  color: rgba(70, 71, 91, 0.8705882353);
}

.EventCustomTable_actionbtndark__Q-Xp4 {
  color: #60677e;
}

/* 
profile dropdowntheme
*/
.EventCustomTable_profiledropdownlight__yn\\+M0 {
  background-color: #fff;
}

.EventCustomTable_profiledropdowndark__U-c\\+v {
  background-color: #151521;
}

.EventCustomTable_settingsection__BRb8e #EventCustomTable_addform__EvGbn.EventCustomTable_formthemedark__pMIn4 .EventCustomTable_savebtn__64s4O {
  background-color: #3b82f6;
  color: #fff;
}

#EventCustomTable_addform__EvGbn.EventCustomTable_formthemedark__pMIn4 .EventCustomTable_savebtn__64s4O {
  background-color: #3b82f6;
  color: #fff;
}

.EventCustomTable_profile_conatiner__k-685 {
  border-radius: 5px !important;
}

.EventCustomTable_bodythemedark__qLtQS .EventCustomTable_ag-theme-alpine__IEojh .EventCustomTable_ag-row__TZELq {
  background: #000 !important;
}

.EventCustomTable_bodythemedark__qLtQS .EventCustomTable_formbtn__SUWQ4 {
  background-color: #3b82f6;
}

.EventCustomTable_bodythemedark__qLtQS .EventCustomTable_formbtn__SUWQ4:hover {
  background-color: #2563eb;
}

.EventCustomTable_bodythemedark__qLtQS .EventCustomTable_resetbtn__9b4\\+x {
  color: #fff;
  background-color: transparent;
  border: solid 1px #3b82f6;
}

.EventCustomTable_bodythemedark__qLtQS .EventCustomTable_resetbtn__9b4\\+x:hover {
  background-color: #3b82f6;
}

.EventCustomTable_headingdark__0WCp8 span {
  background-color: #132337;
}

.EventCustomTable_resetbtn__9b4\\+x {
  font-size: 16px !important;
  font-weight: 600 !important;
  border-radius: 5px !important;
  background-color: transparent !important;
  border: solid 1px #131F43 !important;
  color: #131F43 !important;
  min-width: 113px !important;
}

.EventCustomTable_resetbtn__9b4\\+x:hover,
.EventCustomTable_resetbtn__9b4\\+x:active,
.EventCustomTable_resetbtn__9b4\\+x:focus {
  background-color: #131F43 !important;
  color: #fff !important;
}

.EventCustomTable_addBtn__9RhtQ {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.EventCustomTable_addDltBtn__t-Q7H {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.EventCustomTable_addbtnlight__eTlom {
  background-color: #38A169;
}

.EventCustomTable_addbtndark__bMr9E {
  background-color: #3b82f6;
}

.EventCustomTable_addbtndark__bMr9E:hover {
  background-color: #2563eb;
}

.EventCustomTable_formthemedark__pMIn4 label {
  color: #92afd3;
}

.EventCustomTable_addBtn__9RhtQ svg {
  margin-right: 10px;
  position: relative;
  top: 2px;
}

.EventCustomTable_addBtn__9RhtQ:hover {
  color: #fff;
  background-color: #38A169;
  border: none;
}

.EventCustomTable_cust_addBtn__vv9eT.EventCustomTable_addBtn__9RhtQ svg {
  top: 2px;
}

.EventCustomTable_deleteBtn__E3Fhe {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.EventCustomTable_deleteBtn__E3Fhe {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.EventCustomTable_deleteBtn__E3Fhe:active,
.EventCustomTable_deleteBtn__E3Fhe:focus {
  background-color: #F94747 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.EventCustomTable_deleteBtn__E3Fhe svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.EventCustomTable_deleteBtn__E3Fhe:hover,
.EventCustomTable_deleteBtn__E3Fhe:active,
.EventCustomTable_deleteBtn__E3Fhe:focus {
  background-color: #F94747;
  color: #fff;
  border: none;
}

.EventCustomTable_confirmBtn__I7fCu {
  background-color: #131F43 !important;
  min-width: 130px !important;
  height: 50px !important;
  color: #fff !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  border: none !important;
}

.EventCustomTable_confirmBtn__I7fCu:hover,
.EventCustomTable_confirmBtn__I7fCu:active,
.EventCustomTable_confirmBtn__I7fCu:focus {
  background-color: #0f1824 !important;
}

.EventCustomTable_confirmBtn__I7fCu svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.EventCustomTable_delPopContainer__95uSG .EventCustomTable_modal-body__U1PVI {
  padding: 35px;
  text-align: center;
}

.EventCustomTable_delPopContainer__95uSG .EventCustomTable_delet_icon__irRuE {
  margin-bottom: 11px;
}

.EventCustomTable_delPopContainer__95uSG p {
  color: #131f43;
  font-size: 14px;
  font-weight: 700;
  padding: 0 20px;
}

.EventCustomTable_arrowback__sweN4 svg {
  fill: #000;
}

.EventCustomTable_bodythemedark__qLtQS .EventCustomTable_arrowback__sweN4 {
  background-color: rgba(59, 130, 246, 0.2);
  color: #3b82f6;
}

.EventCustomTable_bodythemedark__qLtQS .EventCustomTable_arrowback__sweN4 svg {
  fill: #3b82f6;
}

.EventCustomTable_bodythemedark__qLtQS .EventCustomTable_drpdwn_btn__9Lm0- {
  background-color: #132337;
}

.EventCustomTable_bodythemedark__qLtQS .EventCustomTable_empname__MlIqa {
  color: #92afd3 !important;
}

.EventCustomTable_bodythemedark__qLtQS .EventCustomTable_navitemli__3wEvf a {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.EventCustomTable_bodythemedark__qLtQS .EventCustomTable_tabnavli__i6PCO a.EventCustomTable_settingsgeneral__ckofZ,
.EventCustomTable_bodythemedark__qLtQS .EventCustomTable_tabnavli__i6PCO a.EventCustomTable_settingslinks__kqyuO:hover {
  background-color: #3b82f6;
  color: #fff;
}

.EventCustomTable_bodythemedark__qLtQS .EventCustomTable_tabnavli__i6PCO a.EventCustomTable_settingslinks__kqyuO {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.EventCustomTable_headerthemedark__k1vRs .EventCustomTable_dropdown_menu_contain__jxRe4 {
  background-color: #1c2e45;
  color: #fff;
}

.EventCustomTable_headerthemedark__k1vRs .EventCustomTable_dropdown_menu_contain__jxRe4 ul li a,
.EventCustomTable_headerthemedark__k1vRs .EventCustomTable_dropdown_menu_contain__jxRe4 .EventCustomTable_dropdown_item__m3Nvq,
.EventCustomTable_headerthemedark__k1vRs .EventCustomTable_dropdown_menu_contain__jxRe4 .EventCustomTable_dropdown_item__m3Nvq h5 {
  color: #fff;
}

.EventCustomTable_headerthemedark__k1vRs .EventCustomTable_dropdown_menu_contain__jxRe4 ul li a:hover,
.EventCustomTable_headerthemedark__k1vRs .EventCustomTable_dropdown_menu_contain__jxRe4 .EventCustomTable_dropdown_item__m3Nvq:hover {
  background-color: #132337;
  color: #fff;
}

.EventCustomTable_dropdown_item__m3Nvq:active {
  background-color: #F5F6FA;
}

.EventCustomTable_profile_arrrow_dwn__sVo-X {
  stroke: #132337;
}

.EventCustomTable_headerthemedark__k1vRs .EventCustomTable_profile_arrrow_dwn__sVo-X {
  stroke: #fff;
}

.EventCustomTable_dateinputbox1__gNe5E input,
.EventCustomTable_dateinputbox1__gNe5E span {
  color: #fff !important;
}

/* LOGOUT MODAL */
.EventCustomTable_delPopContainer__95uSG .EventCustomTable_modal-content__JLLTS {
  border-radius: 10px;
  min-width: 399px;
}

.EventCustomTable_larg_model__pWOWj .EventCustomTable_modal-dialog__1wYP\\+ {
  max-width: 100% !important;
}

.EventCustomTable_larg_model__pWOWj .EventCustomTable_modal-content__JLLTS {
  /* display: inline-block; */
  height: 100%;
  max-width: 900px;
  margin: auto;
  border-radius: 54px !important;
  background: #FFF;
  padding: 53px 53px 23px;
}

.EventCustomTable_larg_model__pWOWj .EventCustomTable_modal-header__v-3Bv {
  padding: 0px 0px 23px;
  border-bottom: 1px dashed #D4D9EE;
  display: block;
}

body .EventCustomTable_btn-primary__bWb5o:hover {
  background-color: transparent;
  border-color: #131F43;
  color: #131F43;
  fill: #131F43;
  border: 1px solid;
}

.EventCustomTable_form-select__HWcjy {
  display: block;
  width: 100%;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  -moz-padding-start: calc(0.75rem - 3px);
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
}

thead .EventCustomTable_CustomTable_tableheadlight__HuHZw__qFUJW th:first-child,
thead .EventCustomTable_CustomTable_tableheaddark__nwqb4__0h5ze th:first-child {
  border-radius: 5px 0 0 0px;
  display: math;
}

th:first-child {
  border-radius: 0px;
  position: absolute;
}

@media only screen and (max-width: 1200px) {
  .EventCustomTable_tableheadlight__WYBfi th {
    min-width: 270px;
  }
}
@media only screen and (max-width: 1024px) {
  .EventCustomTable_dashboard__3q6ll {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    padding: 10px 10px !important;
    overflow-x: hidden !important;
  }
  .EventCustomTable_cont2__Brv3d {
    height: auto !important;
    padding-bottom: 10px !important;
  }
}
@media only screen and (max-width: 998px) {
  /* #dashboardcont2{
    height: auto !important;
  }*/
}
@media only screen and (max-width: 767px) {
  .EventCustomTable_sectionright__M78q0 {
    float: unset !important;
  }
  .EventCustomTable_dashboard__3q6ll {
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 600px) {
  .EventCustomTable_cont2__Brv3d {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 10px 10px 15px !important;
  }
  .EventCustomTable_bodythemelight__DjJjM,
.EventCustomTable_bodythemedark__qLtQS {
    padding-top: 110px;
  }
  .EventCustomTable_delPopContainer__95uSG .EventCustomTable_modal-content__JLLTS {
    min-width: 100%;
  }
  .EventCustomTable_delPopContainer__95uSG .EventCustomTable_modal-body__U1PVI {
    padding: 15px;
  }
  .EventCustomTable_larg_model__pWOWj .EventCustomTable_modal-content__JLLTS {
    border-radius: 20px !important;
    padding: 22px;
  }
}
@media (min-width: 576px) {
  .EventCustomTable_exer_modal_contain__wLPOn .EventCustomTable_modal-dialog__1wYP\\+ {
    max-width: 1055px;
  }
  .EventCustomTable_delPopContainer__95uSG .EventCustomTable_modal-dialog__1wYP\\+ {
    max-width: 350px;
  }
  /*.tableheadlight th {
    min-width: 120px;
  } */
}
/* vk new changes */
.EventCustomTable_active_show_outer__KPVlb h2 {
  color: var(--Font-black, #0B0D0F);
  font-family: Urbanist;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
@media screen and (max-width: 768px) {
  .EventCustomTable_active_show_outer__KPVlb h2 {
    margin-top: 15px;
  }
}
.EventCustomTable_active_show_outer__KPVlb .EventCustomTable_active_show_inner__vZMzv {
  width: 100%;
  display: block;
}
.EventCustomTable_active_show_outer__KPVlb .EventCustomTable_active_show_inner__vZMzv .EventCustomTable_act_box_img__goHjk {
  margin-bottom: 12px;
  min-height: 400px;
  object-fit: cover;
  overflow: hidden;
  height: 400px;
  max-height: 400px;
}
@media (max-width: 767px) {
  .EventCustomTable_active_show_outer__KPVlb .EventCustomTable_active_show_inner__vZMzv .EventCustomTable_act_box_img__goHjk {
    min-height: 300px;
    height: 300px;
    max-height: 300px;
  }
}
.EventCustomTable_active_show_outer__KPVlb .EventCustomTable_active_show_inner__vZMzv .EventCustomTable_act_box_img__goHjk img {
  max-height: 400px;
  /* align-self: stretch; */
  width: 100%;
  height: 100%;
  border-radius: 12px;
  object-fit: cover;
}
.EventCustomTable_active_show_outer__KPVlb .EventCustomTable_active_show_inner__vZMzv .EventCustomTable_act_box_cnt__uIHod {
  width: 100%;
  display: block;
}
.EventCustomTable_active_show_outer__KPVlb .EventCustomTable_active_show_inner__vZMzv .EventCustomTable_act_box_cnt__uIHod svg {
  flex-shrink: 0;
}
.EventCustomTable_active_show_outer__KPVlb .EventCustomTable_active_show_inner__vZMzv .EventCustomTable_act_box_cnt__uIHod .EventCustomTable_act_box_bdg__UMXBl {
  width: 100%;
  margin-bottom: 12px;
}
.EventCustomTable_active_show_outer__KPVlb .EventCustomTable_active_show_inner__vZMzv .EventCustomTable_act_box_cnt__uIHod .EventCustomTable_act_box_bdg__UMXBl span {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) right top no-repeat;
  width: 111px;
  display: block;
  height: 34px;
  color: var(--White, #FFF);
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  padding: 3px 8px;
}
.EventCustomTable_active_show_outer__KPVlb .EventCustomTable_active_show_inner__vZMzv .EventCustomTable_act_box_cnt__uIHod .EventCustomTable_act_box_bdg__UMXBl .EventCustomTable_sold__Da1aU {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) right top no-repeat !important;
}
.EventCustomTable_active_show_outer__KPVlb .EventCustomTable_active_show_inner__vZMzv .EventCustomTable_act_box_cnt__uIHod h3 {
  color: var(--Secondary, #132941);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 26.304px;
  margin: 0;
}
.EventCustomTable_active_show_outer__KPVlb .EventCustomTable_active_show_inner__vZMzv .EventCustomTable_act_box_cnt__uIHod p {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 5px;
}
.EventCustomTable_active_show_outer__KPVlb .EventCustomTable_active_show_inner__vZMzv .EventCustomTable_act_box_cnt__uIHod p span {
  color: var(--Light-1, #736B66);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 26.304px;
}
.EventCustomTable_active_show_outer__KPVlb .EventCustomTable_active_show_inner__vZMzv .EventCustomTable_act_box_cnt__uIHod p .EventCustomTable_timezone_code_pill__jkDkG {
  display: inline-block;
  padding: 2px 8px;
  margin-left: 4px;
  background: #e0f2fe;
  color: #0369a1;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
  border-radius: 6px;
}

/* vk new changes */
#EventCustomTable_attent_details_row1__xGhlL {
  margin-bottom: 0 !important;
}

.EventCustomTable_attent_details__VXDMx .EventCustomTable_attent_details_inner__5XlhJ {
  display: flex;
  gap: 61px;
  padding: 20px;
  border-radius: 5px;
  background: #FFF;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);
  align-items: center;
}
@media (max-width: 576px) {
  .EventCustomTable_attent_details__VXDMx .EventCustomTable_attent_details_inner__5XlhJ {
    display: block !important;
  }
}
@media (max-width: 992px) {
  .EventCustomTable_attent_details__VXDMx .EventCustomTable_attent_details_inner__5XlhJ {
    display: flex;
    gap: 20px;
    align-items: start;
  }
}
.EventCustomTable_attent_details__VXDMx .EventCustomTable_attent_details_inner__5XlhJ .EventCustomTable_attent_details_inner_l__U6LHL img {
  width: 187px;
  height: 207px;
  flex-shrink: 0;
  object-fit: cover;
}
.EventCustomTable_attent_details__VXDMx .EventCustomTable_attent_details_inner__5XlhJ .EventCustomTable_attent_details_inner_r__\\+kMap {
  flex: 1 1;
}
.EventCustomTable_attent_details__VXDMx .EventCustomTable_attent_details_inner__5XlhJ .EventCustomTable_attent_details_inner_r__\\+kMap .EventCustomTable_attent_details_row__WnSeV {
  display: flex;
  gap: 20px;
  margin-bottom: 28px;
}
@media (max-width: 992px) {
  .EventCustomTable_attent_details__VXDMx .EventCustomTable_attent_details_inner__5XlhJ .EventCustomTable_attent_details_inner_r__\\+kMap .EventCustomTable_attent_details_row__WnSeV {
    margin-bottom: 0px;
    display: inline-block;
    width: 100%;
  }
}
.EventCustomTable_attent_details__VXDMx .EventCustomTable_attent_details_inner__5XlhJ .EventCustomTable_attent_details_inner_r__\\+kMap .EventCustomTable_attent_details_row__WnSeV .EventCustomTable_attent_details_row_box__a3QTl {
  flex: 1 1;
  width: 22%;
}
@media (max-width: 576px) {
  .EventCustomTable_attent_details__VXDMx .EventCustomTable_attent_details_inner__5XlhJ .EventCustomTable_attent_details_inner_r__\\+kMap .EventCustomTable_attent_details_row__WnSeV .EventCustomTable_attent_details_row_box__a3QTl {
    margin: 15px 0px 10px !important;
    width: 100% !important;
  }
}
@media (max-width: 992px) {
  .EventCustomTable_attent_details__VXDMx .EventCustomTable_attent_details_inner__5XlhJ .EventCustomTable_attent_details_inner_r__\\+kMap .EventCustomTable_attent_details_row__WnSeV .EventCustomTable_attent_details_row_box__a3QTl {
    margin-bottom: 15px;
    float: left;
    margin-right: 0;
    width: 50%;
    padding-right: 10px;
  }
}
.EventCustomTable_attent_details__VXDMx .EventCustomTable_attent_details_inner__5XlhJ .EventCustomTable_attent_details_inner_r__\\+kMap .EventCustomTable_attent_details_row__WnSeV .EventCustomTable_attent_details_row_box__a3QTl p {
  margin-bottom: 10px;
  color: #727272;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.EventCustomTable_attent_details__VXDMx .EventCustomTable_attent_details_inner__5XlhJ .EventCustomTable_attent_details_inner_r__\\+kMap .EventCustomTable_attent_details_row__WnSeV .EventCustomTable_attent_details_row_box__a3QTl h5 {
  color: #131F43;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  word-wrap: break-word;
}
.EventCustomTable_attent_details__VXDMx .EventCustomTable_attent_details_inner__5XlhJ .EventCustomTable_attent_details_inner_r__\\+kMap .EventCustomTable_attent_details_row_last__OcVmB {
  margin-bottom: 0px !important;
}
.EventCustomTable_attent_details__VXDMx .EventCustomTable_attent_details_inner__5XlhJ .EventCustomTable_attent_details_inner_r__\\+kMap .EventCustomTable_attent_details_row_last__OcVmB.EventCustomTable_interesting_fact__jFW2Y {
  padding-top: 30px;
}
.EventCustomTable_attent_details__VXDMx .EventCustomTable_attent_details_inner__5XlhJ .EventCustomTable_attent_details_inner_r__\\+kMap .EventCustomTable_attent_details_row_last__OcVmB.EventCustomTable_interesting_fact__jFW2Y .EventCustomTable_attent_details_row_box__a3QTl {
  width: 100%;
}
.EventCustomTable_attent_details__VXDMx .EventCustomTable_attent_details_inner__5XlhJ .EventCustomTable_attent_details_inner_r__\\+kMap .EventCustomTable_attent_details_row_last__OcVmB.EventCustomTable_interesting_fact__jFW2Y .EventCustomTable_attent_details_row_box__a3QTl h5 {
  color: #131F43;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}

.EventCustomTable_showbox_sec__8vZvr {
  display: flex;
  justify-content: flex-start;
  gap: 0;
  flex-direction: row;
  flex-wrap: wrap;
}
@media screen and (max-width: 500px) {
  .EventCustomTable_showbox_sec__8vZvr {
    justify-content: center;
  }
}

.EventCustomTable_show_box_main__9Cocn {
  margin: 10px 0px;
}
.EventCustomTable_show_box_main__9Cocn .EventCustomTable_show_box__opAYs {
  min-height: 600px;
  width: 300px;
  float: left;
  margin-right: 20px;
  margin-bottom: 20px;
  cursor: pointer;
}
@media (max-width: 1024px) {
  .EventCustomTable_show_box_main__9Cocn .EventCustomTable_show_box__opAYs {
    margin-right: 18px;
  }
}
@media (max-width: 767px) {
  .EventCustomTable_show_box_main__9Cocn .EventCustomTable_show_box__opAYs {
    min-height: 500px;
    width: 200px !important;
  }
}
.EventCustomTable_show_box_main__9Cocn .EventCustomTable_show_box__opAYs img {
  max-height: 400px;
  height: 100%;
  width: 100%;
}
@media (max-width: 767px) {
  .EventCustomTable_show_box_main__9Cocn .EventCustomTable_show_box__opAYs img {
    max-height: 300px !important;
  }
}
.EventCustomTable_show_box_main__9Cocn .EventCustomTable_show_box__opAYs:last-child {
  margin-right: 0px !important;
}
.EventCustomTable_show_box_main__9Cocn .EventCustomTable_no_show_box__uTi8N {
  width: 350px;
  margin: 0 auto 20px;
  display: block;
}
@media (max-width: 767px) {
  .EventCustomTable_show_box_main__9Cocn .EventCustomTable_no_show_box__uTi8N {
    width: 250px !important;
  }
}
.EventCustomTable_show_box_main__9Cocn .EventCustomTable_no_show_box__uTi8N img {
  max-height: 450px;
  height: 100%;
  width: 100%;
}
@media (max-width: 767px) {
  .EventCustomTable_show_box_main__9Cocn .EventCustomTable_no_show_box__uTi8N img {
    max-height: 350px !important;
  }
}
.EventCustomTable_show_box_main__9Cocn .EventCustomTable_no_show_box__uTi8N h6 {
  color: #000;
  text-align: center;
  font-size: 26px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-top: 20px;
}
@media only screen and (max-width: 600px) {
  .EventCustomTable_show_box_main__9Cocn .EventCustomTable_no_show_box__uTi8N h6 {
    font-size: 20px;
  }
}

.EventCustomTable_attent_flex__WYsFd {
  justify-content: space-between !important;
  gap: 30px;
  align-items: center;
}
.EventCustomTable_attent_flex__WYsFd h5 {
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
}

#EventCustomTable_container__ZqObS {
  padding: 0px;
}
#EventCustomTable_container__ZqObS h5 {
  margin-top: 15px;
}

#EventCustomTable_tableheading__ePGAx {
  font-size: 16px;
  margin-top: 20px;
}

.EventCustomTable_search_box__0l2fh {
  position: relative;
}

#EventCustomTable_spinner__qqFq6 {
  float: right;
  margin-top: -25px;
  position: relative;
  z-index: 1;
  margin-right: 10px;
  cursor: pointer;
  color: #131F43;
}

.EventCustomTable_tbl_sl__CiOby {
  min-width: 10px !important;
}

.EventCustomTable_tablebtn__2Qu81 {
  width: 70px;
  padding: 6px;
  border: none;
  background-color: #131F43;
  border-radius: 5px;
  color: #fff;
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 14px;
}
.EventCustomTable_tablebtn__2Qu81:hover {
  background-color: rgba(37, 105, 109, 0.864);
}

.EventCustomTable_activeEventCard__RgCH2 {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  background-color: #f9f9f9;
  border-radius: 8px;
  width: 500px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 50px;
  margin-top: 20px;
  cursor: pointer;
}
@media screen and (max-width: 768px) {
  .EventCustomTable_activeEventCard__RgCH2 {
    width: 100%;
    object-fit: contain;
    align-items: center !important;
    padding: 0 5px;
  }
}

.EventCustomTable_eventImage__HV7v7 {
  width: 460px;
  height: 250px;
  object-fit: cover;
  margin: 20px;
  border-radius: 5px;
}
@media screen and (max-width: 768px) {
  .EventCustomTable_eventImage__HV7v7 {
    width: 100% !important;
    object-fit: contain;
  }
}

.EventCustomTable_eventDetails__qM9o0 {
  padding: 0 15px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
@media screen and (max-width: 768px) {
  .EventCustomTable_eventDetails__qM9o0 {
    padding: 0 15px 15px 15px;
  }
}

.EventCustomTable_eventTitle__7fG9k {
  font-size: 18px;
  font-weight: bold;
  margin: 0;
  color: #131F43;
}

.EventCustomTable_eventDescription__OCusY {
  color: #727272;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  margin-top: 15px;
}

.EventCustomTable_eventDescription1__IaIJ5 {
  color: #727272;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  margin-top: 15px;
}

table {
  border-collapse: separate !important;
  border-spacing: 0 6px !important;
}

td:first-child,
th:first-child {
  border-radius: 8px 0 0 8px;
}

td:last-child,
th:last-child {
  border-radius: 0 8px 8px 0;
}

.EventCustomTable_tableheaddiv__4JF3z {
  display: flex;
}

th,
td {
  font-size: 15px;
}

.EventCustomTable_tableheading__ePGAx {
  padding: 0.8rem 1rem !important;
  min-width: 150px !important;
}

td {
  padding: 0.5rem 0.5rem !important;
  line-height: 15px;
}

.EventCustomTable_sortbtn__ARt-g {
  border: none;
  background: none;
  color: #6E6E6E;
}

.EventCustomTable_order_date__ixecV {
  margin-top: 5px;
  font-size: 12px;
  color: #000;
  font-weight: normal;
}

h6 {
  color: #000;
}

.EventCustomTable_norecord__iOTnW {
  font-size: 22px;
  margin-top: 10px;
  color: #939090;
}

.EventCustomTable_norecordsdiv__zyUIh {
  position: absolute;
  left: 42%;
  margin-top: 2%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.EventCustomTable_sectionright__M78q0 {
  float: right;
  display: flex;
}
.EventCustomTable_sectionright__M78q0 #EventCustomTable_dropdown__vscmA {
  margin: 0px 10px 10px 10px;
}
.EventCustomTable_sectionright__M78q0 #EventCustomTable_dropdown__vscmA button {
  background-color: #131F43;
  border-radius: 5px;
  border: none;
  box-shadow: none;
  font-size: 14px;
  min-width: 140px;
  min-height: 44px;
}
.EventCustomTable_sectionright__M78q0 a {
  font-size: 14px;
}
.EventCustomTable_sectionright__M78q0 #EventCustomTable_del_icon__almwv {
  font-size: 12px;
  margin-left: 5px;
}

.EventCustomTable_no_evnt__H6cQu {
  text-align: center;
  margin: 1.5%;
}
.EventCustomTable_no_evnt__H6cQu img {
  max-width: 374px;
}
@media only screen and (max-width: 600px) {
  .EventCustomTable_no_evnt__H6cQu img {
    max-width: 250px;
  }
}
.EventCustomTable_no_evnt__H6cQu h6 {
  color: #000;
  text-align: center;
  font-size: 26px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-top: 20px;
}
@media only screen and (max-width: 600px) {
  .EventCustomTable_no_evnt__H6cQu h6 {
    font-size: 20px;
  }
}
.EventCustomTable_no_evnt__H6cQu button {
  padding: 2px 20px;
  margin-top: 20px;
}

@media only screen and (max-width: 600px) {
  #EventCustomTable_dashboardcont2__lDu7a {
    width: calc(100% - 50px);
    left: 50px;
    position: relative;
    padding: 30px;
  }
}
tr:nth-child(even) {
  background-color: #fcfcfc;
}`, "",{"version":3,"sources":["webpack://./src/styles/Variables/Variables.scss","webpack://./src/components/EventTable/EventCustomTable.module.scss"],"names":[],"mappings":"AAAA;;EAAA;AAkDA;;EAAA;AAWA;;CAAA;AAKA;;CAAA;AASA;;CAAA;AAQA;;CAAA;AAMA;;CAAA;AAIA;EACE,yBAhBe;EAiBf,kBAAA;EACA,WAhBc;EAiBd,aAhBiB;EAiBjB,kBAAA;EACA,2BAAA;EACA,yBA1FO;EA2FP,gBAAA;EACA,kBAAA;ACvEF;;AD0EA;EACE,yBAAA;EACA,yBAjGO;EAkGP,kBAAA;ACvEF;;AD0EA;;;EAGE,yBApEoB;ACHtB;;AD0EA;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;ACvEF;;AD0EA;;CAAA;AAIA;EACE,wBA1CU;EA2CV,UA1CS;EA2CT,kBAAA;EACA,aAlDiB;EAmDjB,kBAAA;EACA,mBA3HO;EA4HP,+BAAA;EACA,YAAA;EACA,2BAAA;EACA;;;GAAA;ACrEF;;AD2EA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;ACxEF;;AD6EA;EACE,2BAAA;AC1EF;;AD6EA;EACE,yBAAA;EACA,YAAA;AC1EF;;AD8EA;EACE,YAAA;AC3EF;;AD8EA;EACE,sBA9GY;ACmCd;;AD8EA;;CAAA;AAGA;EACE,sBArHY;EAsHZ,iBAAA;AC3EF;;AD8EA;EACE,yBArIgB;EAsIhB,iBAAA;AC3EF;;AD8EA;EACE,yBAAA;AC3EF;;AD8EA;;CAAA;AAGA;EACE,sBAtIY;AC2Dd;;AD8EA;EACE,yBArJgB;AC0ElB;;AD8EA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,MAAA;AC3EF;;AD8EA;;CAAA;AAGA;EACE,yBAAA;AC3EF;;AD8EA;EACE,yBA1KgB;AC+FlB;;AD8EA;;CAAA;AAGA;EACE,yBAAA;AC3EF;;AD8EA;EACE,yBAAA;AC3EF;;AD8EA;;EAEE,sBAAA;AC3EF;;AD8EA;EACE,yBA5LsB;EA6LtB,cAvMkB;AC4HpB;;AD8EA;EACE,sCAAA;EACA,sBAAA;EACA,oCAAA;AC3EF;;AD8EA;EACE,yBAAA;AC3EF;;AD8EA;EACE,sBAAA;EACA,oCAAA;AC3EF;;AD8EA;EACE,0BAAA;AC3EF;;AD8EA;EACE,uBAAA;AC3EF;;AD8EA;EACE,0BAAA;AC3EF;;AD8EA;EACE,uBAAA;AC3EF;;AD8EA;;EAEE,qBAAA;AC3EF;;AD8EA;EACE,yBArOsB;EAsOtB,WA7NY;ACkJd;;AD8EA;;CAAA;AAGA;EACE,cAjOe;ACsJjB;;AD8EA;EACE,cArOe;AC0JjB;;AD8EA;;CAAA;AAGA;EACE,sBA/OY;EAgPZ,YAAA;AC3EF;;AD8EA;EACE,yBA/PgB;EAgQhB,WArPY;EAsPZ,YAAA;AC3EF;;AD8EA;EACE,cAvPe;AC4KjB;;AD8EA;;CAAA;AAGA;EACE,yBA9Sc;EA+Sd,8BAAA;AC3EF;;AD8EA;EACE,WAtQY;AC2Ld;;AD8EA;;EAEE,0BAAA;AC3EF;;AD8EA;;EAEE,0BAAA;AC3EF;;AD8EA;EACE,kBAAA;AC3EF;;AD8EA;EACE,kBAAA;AC3EF;;AD8EA;EACE,oCAAA;EACA,gCAAA;AC3EF;;AD8EA;EACE,yBAzRkB;EA0RlB,WAlSY;ACuNd;;AD8EA;EACE,yBAAA;AC3EF;;AD8EA;EACE,iBAAA;AC3EF;;AD8EA;;EAEE,+BAAA;EACA,iBAAA;AC3EF;;AD8EA;EACE,sBApTY;ACyOd;AD6EE;EACE,sBAvTU;EAwTV,YAAA;AC3EJ;AD6EE;EACA,iBAAA;AC3EF;;ADgFA;EACE,0CAAA;EACA,cA/Te;ACkPjB;AD+EE;EACE,yCAAA;EACA,eAAA;AC7EJ;;ADiFA;;CAAA;AAGA;EACE,yBAAA;EACA,0BAAA;AC9EF;;ADiFA;EACE,yBAAA;EACA,0BAAA;AC9EF;;ADiFA;;CAAA;AAGA;EACE,sBA3VY;EA4VZ,yBAAA;EACA,qDAAA;AC9EF;;ADiFA;EACE,yBAzVkB;EA0VlB,yBAAA;EACA,eAAA;AC9EF;ADgFE;EACE,cAnWa;ACqRjB;;ADmFA;;CAAA;AAGA;EACE,yBAlXgB;ACkSlB;;ADmFA;EACE,yBAAA;EACA,yBAAA;AChFF;;ADmFA;EACE,yBAlYoB;EAmYpB,yBAAA;AChFF;;ADmFA;EACE,UAAA;EACA,eAAA;EACA,eAAA;AChFF;;ADmFA;;CAAA;AAGA;EACE,sBAtYY;ACsTd;;ADmFA;EACE,yBAlYkB;ACkTpB;;ADoFA;;CAAA;AAGA;EACE,iGAAA;EACA,sBAnZY;ACkUd;;ADoFA;EACE,mBAAA;ACjFF;;ADoFA;EACE,gGAAA;EACA,sBA5ZY;AC2Ud;;ADoFA;EACE,mBAAA;ACjFF;;ADoFA;EACE,gGAAA;EACA,sBAraY;ACoVd;;ADoFA;EACE,mBAAA;ACjFF;;ADoFA;EACE,gGAAA;EACA,sBA9aY;AC6Vd;;ADoFA;EACE,mBAAA;ACjFF;;ADoFA;;;;;;;;EAQE,WA7bY;AC4Wd;;ADoFA;;CAAA;AAGA;EACE,qCAAA;ACjFF;;ADoFA;EACE,cArce;ACoXjB;;ADqFA;;CAAA;AAGA;EACE,sBAAA;AClFF;;ADqFA;EACE,yBAAA;AClFF;;ADqFA;EACE,yBAzekB;EA0elB,WAzdY;ACuYd;;ADqFA;EACE,yBA9ekB;EA+elB,WA9dY;AC4Yd;;ADqFA;EACE,6BAAA;AClFF;;ADqFA;EACE,2BAAA;AClFF;;ADqFA;EACE,yBA3fkB;ACyapB;;ADqFA;EACE,yBA9fwB;AC4a1B;;ADqFA;EACE,WAlfY;EAmfZ,6BAAA;EACA,yBAAA;AClFF;;ADqFA;EACE,yBAzgBkB;ACubpB;;ADsFA;EACE,yBAxgBgB;ACqblB;;ADsFA;EACE,0BAAA;EACA,2BAAA;EACA,6BAAA;EACA,wCAAA;EACA,oCAAA;EACA,yBAAA;EACA,2BAAA;ACnFF;;ADsFA;;;EAGE,oCAAA;EACA,sBAAA;ACnFF;;ADsFA;EACE,gBAAA;EACA,YAAA;EACA,WAphBY;EAqhBZ,yBAhjBY;EAijBZ,YAAA;EACA,eAAA;EACA,gBA3kBc;ACwfhB;;ADsFA;EACE,gBAAA;EACA,YAAA;EACA,WA9hBY;EA+hBZ,yBA1jBY;EA2jBZ,YAAA;EACA,eAAA;EACA,gBArlBc;ACkgBhB;;ADsFA;EACE,yBAjkBY;AC8ed;;ADsFA;EACE,yBA3jBkB;ACwepB;;ADsFA;EACE,yBA9jBwB;AC2e1B;;ADsFA;EACE,cApkBiB;ACifnB;;ADuFA;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;ACpFF;;ADuFA;EACE,WA7jBY;EA8jBZ,yBAzlBY;EA0lBZ,YAAA;ACpFF;;ADuFA;EACE,QAAA;ACpFF;;ADuFA;EACE,gBAAA;EACA,YAAA;EACA,yBA7lBW;EA8lBX,WA1kBY;EA2kBZ,eAAA;EACA,gBA/nBc;EAgoBd,YAAA;ACpFF;;ADuFA;EACE,gBAAA;EACA,YAAA;EACA,yBAvmBW;EAwmBX,WAplBY;EAqlBZ,eAAA;EACA,gBAzoBc;EA0oBd,YAAA;ACpFF;;ADuFA;;EAEE,oCAAA;EACA,sBAAA;EACA,2BAAA;ACpFF;;ADuFA;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;ACpFF;;ADuFA;;;EAGE,yBA9nBW;EA+nBX,WA3mBY;EA4mBZ,YAAA;ACpFF;;ADuFA;EACE,oCAAA;EACA,2BAAA;EACA,uBAAA;EACA,sBAAA;EACA,0BAAA;EACA,2BAAA;EACA,uBAAA;ACpFF;;ADuFA;;;EAGE,oCAAA;ACpFF;;ADuFA;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;ACpFF;;ADyFA;EACE,aAAA;EACA,kBAAA;ACtFF;;ADyFA;EACE,mBAAA;ACtFF;;ADyFA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;ACtFF;;ADyFA;EACE,UAAA;ACtFF;;ADyFA;EACE,yCA3qBc;EA4qBd,cAhrBkB;AC0lBpB;;ADyFA;EACE,aAprBkB;AC8lBpB;;ADyFA;EACE,yBAhrBgB;AC0lBlB;;ADyFA;EACE,yBAAA;ACtFF;;ADyFA;EACE,6BAAA;EACA,yBAAA;EACA,WA/qBY;ACylBd;;ADyFA;;EAEE,yBArsBkB;EAssBlB,WArrBY;AC+lBd;;ADyFA;EACE,6BAAA;EACA,yBAAA;EACA,WA3rBY;ACqmBd;;ADyFA;EACE,yBAxsBsB;EAysBtB,WAhsBY;AC0mBd;;ADyFA;;;EAGE,WAtsBY;ACgnBd;;ADyFA;;EAEE,yBAttBgB;EAutBhB,WA5sBY;ACsnBd;;ADyFA;EACE,yBA9vBO;ACwqBT;;ADyFA;EACE,eA/tBgB;ACyoBlB;;ADyFA;EACE,YAxtBY;ACkoBd;;ADyFA;;EAEE,sBAAA;ACtFF;;ADyFA,iBAAA;AAKA;EACE,mBAAA;EACA,gBAAA;AC1FF;;AD6FA;EACE,0BAAA;AC1FF;;AD6FA;EACE,2BAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,8BAAA;EACA,gBAAA;EACA,uBAAA;AC1FF;;AD6FA;EACE,qBAAA;EACA,iCAAA;EACA,cAAA;AC1FF;;AD6FA;EACE,6BAAA;EACA,qBAAA;EACA,cAAA;EACA,aAAA;EACA,iBAAA;AC1FF;;AD6FA;EACE,cAAA;EACA,WAAA;EACA,0CAAA;EACA,uCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,oEAAA;AC1FF;;AD6FA;;EAEE,0BAAA;EACA,aAAA;AC1FF;;AD6FA;EACE,kBAAA;EACA,kBAAA;AC1FF;;AD6FA;EACE;IACE,gBAAA;EC1FF;AACF;AD6FA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,6BAAA;EC3FF;ED8FA;IACE,uBAAA;IACA,+BAAA;EC5FF;AACF;AD+FA;EACE;;IAAA;AC3FF;ADgGA;EACE;IACE,uBAAA;EC9FF;EDiGA;IACE,6BAAA;EC/FF;AACF;ADkGA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,kCAAA;EChGF;EDmGA;;IAEE,kBAAA;ECjGF;EDoGA;IACE,eAAA;EClGF;EDqGA;IACE,aAAA;ECnGF;EDsGA;IACE,8BAAA;IACA,aAAA;ECpGF;AACF;ADuGA;EACE;IACE,iBAAA;ECrGF;EDwGA;IACE,gBAAA;ECtGF;EDyGA;;KAAA;ACrGF;AD0GA,mBAAA;AAGE;EACE,iCAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AC1GJ;AD2GI;EAPF;IAQI,gBAAA;ECxGJ;AACF;AD2GE;EACE,WAAA;EACA,cAAA;ACzGJ;AD2GI;EACE,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;ACzGN;AD0GM;EAPF;IAQI,iBAAA;IACA,aAAA;IACA,iBAAA;ECvGN;AACF;ADwGM;EACE,iBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;ACtGR;AD0GI;EACE,WAAA;EACA,cAAA;ACxGN;ADyGA;EACE,cAAA;ACvGF;ADyGM;EACE,WAAA;EACA,mBAAA;ACvGR;ADyGQ;EACE,uEAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;ACvGV;AD0GQ;EACE,kFAAA;ACxGV;AD6GM;EACE,gCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,SAAA;AC3GR;AD8GM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AC5GR;AD8GQ;EACE,8BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;AC5GV;AD+GQ;EACE,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;AC7GV;;ADoHA,mBAAA;AACA;EACI,2BAAA;ACjHJ;;ADoHE;EACE,aAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;EACA,mBAAA;ACjHJ;ADmHI;EATF;IAUI,yBAAA;EChHJ;AACF;ADkHI;EAbF;IAcI,aAAA;IACA,SAAA;IACA,kBAAA;EC/GJ;AACF;ADkHM;EACE,YAAA;EACA,aAAA;EACA,cAAA;EACA,iBAAA;AChHR;ADoHI;EACE,SAAA;AClHN;ADoHM;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AClHR;ADoHQ;EALF;IAMI,kBAAA;IACA,qBAAA;IACA,WAAA;ECjHR;AACF;ADmHQ;EACE,SAAA;EACA,UAAA;ACjHV;ADmHU;EAJF;IAKI,gCAAA;IACA,sBAAA;EChHV;AACF;ADkHU;EATF;IAUI,mBAAA;IACA,WAAA;IACA,eAAA;IACA,UAAA;IACA,mBAAA;EC/GV;AACF;ADiHU;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AC/GZ;ADkHU;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;AChHZ;ADqHM;EACE,6BAAA;ACnHR;ADoHQ;EACE,iBAAA;AClHV;ADmHU;EACE,WAAA;ACjHZ;ADkHY;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AChHd;;ADyHC;EACK,aAAA;EACF,2BAAA;EACA,MAAA;EACA,mBAAA;EACA,eAAA;ACtHJ;ADuHI;EANH;IAOK,uBAAA;ECpHJ;AACF;;ADsHA;EACE,gBAAA;ACnHF;ADqHE;EACE,iBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;ACnHJ;ADqHI;EARF;IASI,kBAAA;EClHJ;AACF;ADmHI;EAXF;IAYI,iBAAA;IACA,uBAAA;EChHJ;AACF;ADkHI;EACE,iBAAA;EACA,YAAA;EACA,WAAA;AChHN;ADkHM;EALF;IAMI,4BAAA;EC/GN;AACF;ADkHI;EACE,4BAAA;AChHN;ADoHE;EACE,YAAA;EACA,mBAAA;EACA,cAAA;AClHJ;ADoHI;EALF;IAMI,uBAAA;ECjHJ;AACF;ADmHI;EACE,iBAAA;EACA,YAAA;EACA,WAAA;ACjHN;ADmHM;EALF;IAMI,4BAAA;EChHN;AACF;ADkHI;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AChHN;ADiHM;EARF;IASI,eAAA;EC9GN;AACF;;ADqHA;EACE,yCAAA;EACA,SAAA;EACA,mBAAA;AClHF;ADoHE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;AClHJ;;AAzlCA;EACE,YAAA;AA4lCF;AA3lCE;EACE,gBAAA;AA6lCJ;;AAzlCA;EACE,eAAA;EACA,gBAAA;AA4lCF;;AAzlCA;EACE,kBAAA;AA4lCF;;AAxlCA;EACE,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;EACA,cD0CiB;ACijCnB;;AAxlCA;EACE,0BAAA;AA2lCF;;AAxlCA;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,yBD+BiB;EC9BjB,kBAAA;EACA,WDgBY;ECfZ,gBAAA;EACA,mBAAA;EACA,eAAA;AA2lCF;AAzlCE;EACE,2CDwBiB;ACmkCrB;;AAvlCA;EACE,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,wCAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AA0lCF;AAzlCE;EAXF;IAYI,WAAA;IACA,mBAAA;IACE,8BAAA;IACA,cAAA;EA4lCJ;AACF;;AAxlCA;EACE,YAAA;EACA,aAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;AA2lCF;AA1lCE;EANF;IAOI,sBAAA;IACA,mBAAA;EA6lCF;AACF;;AA1lCA;EACE,eAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;AA6lCF;AA5lCE;EALF;IAMM,yBAAA;EA+lCJ;AACF;;AA3lCA;EACE,eAAA;EACA,iBAAA;EACA,SAAA;EACA,cAAA;AA8lCF;;AA3lCA;EACE,cAAA;EAEF,eAAA;EACA,kBAAA;EACA,gBAAA;EACE,gBAAA;AA6lCF;;AA3lCA;EACE,cAAA;EAEF,eAAA;EACA,kBAAA;EACA,gBAAA;EACE,gBAAA;AA6lCF;;AA1lCA;EACE,oCAAA;EACA,gCAAA;AA6lCF;;AAzlCA;;EAEE,0BAAA;AA4lCF;;AAxlCA;;EAEE,0BAAA;AA2lCF;;AAxlCA;EACE,aAAA;AA2lCF;;AAxlCA;;EAEE,eAAA;AA2lCF;;AAxlCA;EACE,+BAAA;EACA,2BAAA;AA2lCF;;AAxlCA;EACE,iCAAA;EACA,iBAAA;AA2lCF;;AA/kCA;EACE,YAAA;EACA,gBAAA;EACA,cAAA;AAklCF;;AA/kCA;EACE,eAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;AAklCF;;AA/kCA;EACE,WAAA;AAklCF;;AA9kCA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAilCF;;AA/kCA;EACE,kBAAA;EACA,SAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAklCF;;AA/kCA;EACE,YAAA;EACA,aAAA;AAklCF;AAhlCE;EACE,0BAAA;AAklCJ;AA/kCE;EACE,yBDtIe;ECuIf,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAilCJ;AA9kCE;EACE,eAAA;AAglCJ;AA5kCE;EACE,eAAA;EACA,gBAAA;AA8kCJ;;AAzkCA;EACE,kBAAA;EACA,YAAA;AA4kCF;AA1kCE;EACE,gBAAA;AA4kCJ;AA3kCI;EAFF;IAGI,gBAAA;EA8kCJ;AACF;AA3kCE;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AA6kCJ;AA5kCI;EARF;IASI,eAAA;EA+kCJ;AACF;AA5kCE;EACE,iBAAA;EACA,gBAAA;AA8kCJ;;AA1kCA;EACE;IACE,wBD1KQ;IC2KR,UD1KO;IC2KP,kBAAA;IACA,aDlLe;EC+vCjB;AACF;AA1kCA;EACE,yBAAA;AA4kCF","sourcesContent":["/* \nscss\n */\n$font-regular: 400;\n$font-medium: 500;\n$font-semiBold: 600;\n$font-bold: 700;\n$font-extraBold: 800;\n$font-black: 900;\n\n$mainBg: #F5F6FA;\n$primary-color: #131F43;\n$icon-bgcolor: #F6F6F6;\n$text-graycolor: #727272;\n$cardIcon1-bg: #F3F4F8;\n$cardIcon1-darkbg: #30231a;\n$cardIcon1-darkbg-icon: #9d785f;\n$cardIcon2-bg: #FAF4FB;\n$cardIcon2-darkbg: #13252a;\n$cardIcon2-darkbg-icon: #3b606a;\n$cardIcon3-bg: #FAF7F3;\n$cardIcon3-darkbg: #2c1a27;\n$cardIcon3-darkbg-icon: #6c4863;\n$cardIcon4-bg: #F5F9FC;\n$cardIcon4-darkbg: #241d3e;\n$cardIcon4-darkbg-icon: #5f538b;\n$cardIcon2-color: #AC44BB;\n$cardIcon3-color: #D69A5F;\n$cardIcon4-color: #176CA5;\n$green-color: #38A169;\n$darkGreen-color: #207a4a;\n$placeholder-color: #666666;\n$profile-dark-text: #181818;\n$heading : #0B0D0F;\n$light-gray : #999999;\n$menu_icon : #CBCBCB;\n$red-color : #F94747;\n$dark-active-blue : #3b82f6;\n$dark-light-blue : #92afd3;\n$addBtn-dark-blue : #3b82f6;\n$addBtn-dark-blue-hover : #2563eb;\n$backBtn-dark : #3b82f633;\n\n\n\n$darkTheme_blue : #132337;\n$darkTheme_darkBlue : #0f1824;\n$darkTheme_selectBlue : #1c2e45;\n$darkTheme_updateBtn : #0a2574;\n\n/* \nBody Theme Color\n */\n$lightthemecolor: #f3f6f9;\n$darkthemecolor: #151521;\n\n$white-color: #fff;\n$black-color: #1d1d1d;\n$fullBlack-color: #1d1d1d;\n$lightthemetext: #60677e;\n\n/* \nDark Theme Colors\n*/\n$primarydark-color: #132337;\n\n/* \nButton Theme\n*/\n$primary-btncolor: #131F43;\n$secondary-btncolor: rgba(37, 105, 109, 0.864);\n\n$tableheadlightbg: #e9eaf0;\n\n\n/* \nMax Dashboard scss\n*/\n$dashboardwidth: calc(100% - 320px);\n$dashboardposition: absolute;\n$dashboardleft: 290px;\n$dashboardpadding: 30px;\n\n/* \nMin Dashboard scss\n*/\n$dashwidth: calc(100% - 50px);\n$dashleft: 50px;\n\n/* \nMax Dashboard scss\n*/\n\n.dashboard {\n  width: $dashboardwidth;\n  position: relative;\n  left: $dashboardleft;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  min-height: auto !important;\n  background-color: $mainBg;\n  overflow-y: auto;\n  padding-right: 0px;\n}\n\n.dashboardContain {\n  width: calc(100% - 320px);\n  background-Color: $mainBg;\n  border-radius: 8px;\n}\n\n.bodythemedark .dashboardContain,\n.bodythemedark .dashboard,\n.bodythemedark .cont2 {\n  background-Color: $darkTheme_darkBlue;\n}\n\n.top_header .top_header_inner {\n  background-color: transparent;\n  height: auto;\n  overflow-y: unset;\n}\n\n/* \nMin Dashboard scss\n*/\n\n.cont2 {\n  width: $dashwidth;\n  left: $dashleft;\n  position: relative;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  background: $mainBg;\n  /*height: calc(100vh - 160px);*/\n  height: 100%;\n  min-height: auto !important;\n  /* \nbackground-Color: $dashboardbackgroundColor;\n  padding-bottom: 8%;\n*/\n}\n\n.subLink svg {\n  position: relative;\n  top: -2px;\n  left: -7px;\n}\n\n\n\n.cst_vendr input {\n  min-height: 35px !important;\n}\n\n.cst_vendr .form-control {\n  background-color: #f5f6fa;\n  border: none;\n}\n\n\n.footer {\n  height: 70px;\n}\n\nbody {\n  background-color: $white-color;\n}\n\n/* \nTHEME CHANGE\n*/\n.bodythemelight {\n  background-color: $white-color;\n  padding-top: 90px;\n}\n\n.bodythemedark {\n  background-color: $darkTheme_blue;\n  padding-top: 90px;\n}\n\n.bodythemeNew {\n  background-color: #f5f6fa;\n}\n\n/* \nHeader Navbar Theme\n*/\n.headerthemelight {\n  background-color: $white-color;\n}\n\n.headerthemedark {\n  background-color: $darkTheme_blue;\n}\n\n.top_header {\n  min-height: 90px;\n  display: flex;\n  align-items: center;\n  position: fixed;\n  width: 100%;\n  z-index: 2;\n  top: 0;\n}\n\n/* \nLEFT MENU THEME CHANGE\n*/\n.menuthemelight {\n  background-color: #f5f6fa;\n}\n\n.menuthemedark {\n  background-color: $darkTheme_blue;\n}\n\n/* \nLEFT MENU LINKS THEME CHANGE\n*/\n.menulinklight span {\n  color: $placeholder-color !important;\n}\n\n.menulinklight a {\n  color: $menu_icon !important;\n}\n\n.menulinklight:hover span,\n.menulinklight:hover a {\n  color: $white-color !important;\n}\n\n.menulinkdarkSelected {\n  background-color: $darkTheme_selectBlue;\n  color: $dark-active-blue;\n}\n\n.menuthemelight .menulinklightSelected {\n  /*background-color: $lightthemecolor;*/\n  color: $white-color !important;\n  background-color: $primary-color !important;\n}\n\n.menulinkdark {\n  color: $dark-light-blue !important;\n}\n\n.menulinklight:hover {\n  color: $white-color !important;\n  background-color: $primary-color !important;\n}\n\n.menulinklight .sub_arrow svg path {\n  stroke: $menu_icon !important;\n}\n\n.menulinklight:hover .sub_arrow svg path {\n  stroke: $white-color !important;\n}\n\n.menulinkdark .sub_arrow svg path {\n  stroke: $dark-light-blue !important;\n}\n\n.menulinkdark:hover .sub_arrow svg path {\n  stroke: $white-color !important;\n}\n\n.menulinklight:hover svg path,\n.menulinklightSelected svg path {\n  fill: #fff !important;\n}\n\n.menulinkdark:hover {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n/* \nBODY HEADERS\n*/\n.headinglight {\n  color: $lightthemetext;\n}\n\n.headingdark {\n  color: $lightthemetext;\n}\n\n/* \nSEARCH BOX THEME COLOR\n*/\n.searchboxlight {\n  background-color: $white-color;\n  border: none;\n}\n\n.searchboxdark {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n  border: none;\n}\n\n.searchboxdark::placeholder {\n  color: $lightthemetext;\n}\n\n/* \nCUSTOM TABLE THEME COLOR\n*/\n.tableheadlight {\n  background-color: $primary-color;\n  border-radius: 5px 5px 0px 0px;\n}\n\n.tableheadlight th {\n  color: $white-color;\n}\n\nthead .tableheadlight th:first-child,\nthead .tableheaddark th:first-child {\n  border-radius: 5px 0 0 0px;\n}\n\nthead .tableheadlight th:last-child,\nthead .tableheaddark th:last-child {\n  border-radius: 0 5px 0px 0;\n}\n\nth:first-child {\n  border-radius: 0px;\n}\n\ntd:last-child {\n  border-radius: 0px;\n}\n\ntable.table.table-borderless {\n  border-collapse: separate !important;\n  border-spacing: 0 0px !important;\n}\n\n.tableheaddark {\n  background-color: $primarydark-color;\n  color: $white-color;\n}\n\n.table-borderless tr:nth-child(even) {\n  background-color: #F9FAFB;\n}\n\n.table-borderless .left-section {\n  padding-top: 10px;\n}\n\n.tablebodylight td,\n.tablebodydark td {\n  padding: 0.5rem 1rem !important;\n  line-height: 45px;\n}\n\n.tablebodylight {\n  background-color: $white-color;\n\n  &:hover {\n    background-color: $white-color;\n    cursor: auto;\n  }\n  p{\n  line-height: 24px;\n}\n\n}\n\n.tablebodydark {\n  /* background-color: $primarydark-color; */\n  color: $lightthemetext;\n\n  &:hover {\n    background-color: rgba(33, 150, 243, 0.1);\n    cursor: pointer;\n  }\n}\n\n/* \nPAGINATION THEME COLOR\n*/\n.paginationlight {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n.paginationdark {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n/* \nSETTING FORM THEME COLOR\n*/\n.formthemelight {\n  background-color: $white-color;\n  color: $black-color !important;\n  box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n}\n\n.formthemedark {\n  background-color: $primarydark-color;\n  color: $lightthemetext !important;\n  font-size: 14px;\n\n  ::placeholder {\n    color: $lightthemetext;\n  }\n}\n\n\n/* \nVIEW FORM DETAILS BOX THEME COLOR\n*/\n.viewformlight {\n  background-color: $lightthemecolor;\n}\n\n.permissionboxlight {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n}\n\n.permissionboxdark {\n  background-color: $darkTheme_darkBlue;\n  border: solid 1px #242434;\n}\n\n.errormsgclr {\n  color: red;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n/* \nGraph theme\n*/\n.graphclrlight {\n  background-color: $white-color;\n}\n\n.graphclrdark {\n  background-color: $primarydark-color;\n}\n\n\n/* \nCounter theme\n*/\n#card1bglight {\n  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card1bgdark {\n  background: #392f28;\n}\n\n#card2bglight {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card2bgdark {\n  background: #1c3238;\n}\n\n#card3bglight {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card3bgdark {\n  background: #3a2434;\n}\n\n#card4bglight {\n  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card4bgdark {\n  background: #2f264f;\n}\n\n#card1bgdark a,\n#card1bgdark p,\n#card2bgdark a,\n#card2bgdark p,\n#card3bgdark a,\n#card3bgdark p,\n#card4bgdark a,\n#card4bgdark p {\n  color: $white-color;\n}\n\n/* \nAction button theme\n*/\n.actionbtnlight {\n  color: #46475bde;\n}\n\n.actionbtndark {\n  color: $lightthemetext;\n}\n\n\n/* \nprofile dropdowntheme\n*/\n.profiledropdownlight {\n  background-color: #fff;\n}\n\n.profiledropdowndark {\n  background-color: #151521;\n}\n\n.settingsection #addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n#addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.profile_conatiner {\n  border-radius: 5px !important;\n}\n\n.bodythemedark .ag-theme-alpine .ag-row {\n  background: #000 !important;\n}\n\n.bodythemedark .formbtn {\n  background-color: $addBtn-dark-blue;\n}\n\n.bodythemedark .formbtn:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.bodythemedark .resetbtn {\n  color: $white-color;\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n}\n\n.bodythemedark .resetbtn:hover {\n  background-color: $addBtn-dark-blue;\n}\n\n\n.headingdark span {\n  background-color: $darkTheme_blue;\n}\n\n.resetbtn {\n  font-size: 16px !important;\n  font-weight: $font-semiBold !important;\n  border-radius: 5px !important;\n  background-color: transparent !important;\n  border: solid 1px $primary-color !important;\n  color: $primary-color !important;\n  min-width: 113px !important;\n}\n\n.resetbtn:hover,\n.resetbtn:active,\n.resetbtn:focus {\n  background-color: $primary-color !important;\n  color: $white-color !important;\n}\n\n.addBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addDltBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addbtnlight {\n  background-color: $green-color;\n}\n\n.addbtndark {\n  background-color: $addBtn-dark-blue;\n}\n\n.addbtndark:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.formthemedark label {\n  color: $dark-light-blue;\n}\n\n\n.addBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: 2px;\n}\n\n.addBtn:hover {\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n}\n\n.cust_addBtn.addBtn svg {\n  top: 2px;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn:active,\n.deleteBtn:focus {\n  background-color: $red-color !important;\n  color: $white-color !important;\n  box-shadow: none !important;\n}\n\n.deleteBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: -2px;\n}\n\n.deleteBtn:hover,\n.deleteBtn:active,\n.deleteBtn:focus {\n  background-color: $red-color;\n  color: $white-color;\n  border: none;\n}\n\n.confirmBtn {\n  background-color: $primary-color !important;\n  min-width: 130px !important;\n  height: 50px !important;\n  color: $white-color !important;\n  font-size: 16px !important;\n  font-weight: $font-semiBold !important;\n  border: none !important;\n}\n\n.confirmBtn:hover,\n.confirmBtn:active,\n.confirmBtn:focus {\n  background-color: $darkTheme_darkBlue !important;\n}\n\n.confirmBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: -2px;\n}\n\n\n\n.delPopContainer .modal-body {\n  padding: 35px;\n  text-align: center;\n}\n\n.delPopContainer .delet_icon {\n  margin-bottom: 11px;\n}\n\n.delPopContainer p {\n  color: #131f43;\n  font-size: 14px;\n  font-weight: 700;\n  padding: 0 20px;\n}\n\n.arrowback svg {\n  fill: #000;\n}\n\n.bodythemedark .arrowback {\n  background-color: $backBtn-dark;\n  color: $dark-active-blue;\n}\n\n.bodythemedark .arrowback svg {\n  fill: $dark-active-blue;\n}\n\n.bodythemedark .drpdwn_btn {\n  background-color: $darkTheme_blue;\n}\n\n.bodythemedark .empname {\n  color: $dark-light-blue !important;\n}\n\n.bodythemedark .navitemli a {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingsgeneral,\n.bodythemedark .tabnavli a.settingslinks:hover {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingslinks {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a,\n.headerthemedark .dropdown_menu_contain .dropdown_item,\n.headerthemedark .dropdown_menu_contain .dropdown_item h5 {\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a:hover,\n.headerthemedark .dropdown_menu_contain .dropdown_item:hover {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n}\n\n.dropdown_item:active {\n  background-color: $mainBg;\n}\n\n.profile_arrrow_dwn {\n  stroke: $darkTheme_blue;\n}\n\n.headerthemedark .profile_arrrow_dwn {\n  stroke: $white-color;\n}\n\n.dateinputbox1 input,\n.dateinputbox1 span {\n  color: $white-color !important;\n}\n\n/* LOGOUT MODAL */\n.modalStyleLight {}\n\n.modalStyleDark {}\n\n.delPopContainer .modal-content {\n  border-radius: 10px;\n  min-width: 399px;\n}\n\n.larg_model .modal-dialog {\n  max-width: 100% !important;\n}\n\n.larg_model .modal-content {\n  /* display: inline-block; */\n  height: 100%;\n  max-width: 900px;\n  margin: auto;\n  border-radius: 54px !important;\n  background: #FFF;\n  padding: 53px 53px 23px;\n}\n\n.larg_model .modal-header {\n  padding: 0px 0px 23px;\n  border-bottom: 1px dashed #D4D9EE;\n  display: block;\n}\n\nbody .btn-primary:hover {\n  background-color: transparent;\n  border-color: #131F43;\n  color: #131F43;\n  fill: #131F43;\n  border: 1px solid;\n}\n\n.form-select {\n  display: block;\n  width: 100%;\n  padding: .375rem 2.25rem .375rem .75rem;\n  -moz-padding-start: calc(0.75rem - 3px);\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #212529;\n  background-color: #fff;\n  background-image: url(../../assets/select_arow.svg) !important;\n}\n\nthead .CustomTable_tableheadlight__HuHZw th:first-child,\nthead .CustomTable_tableheaddark__nwqb4 th:first-child {\n  border-radius: 5px 0 0 0px;\n  display: math;\n}\n\nth:first-child {\n  border-radius: 0px;\n  position: absolute;\n}\n\n@media only screen and (max-width: 1200px) {\n  .tableheadlight th {\n    min-width: 270px;\n  }\n}\n\n@media only screen and (max-width: 1024px) {\n  .dashboard {\n    width: calc(100% - 50px) !important;\n    left: 50px !important;\n    padding: 10px 10px !important;\n    overflow-x: hidden !important;\n  }\n\n  .cont2 {\n    height: auto !important;\n    padding-bottom: 10px !important;\n  }\n}\n\n@media only screen and (max-width: 998px) {\n  /* #dashboardcont2{\n    height: auto !important;\n  }*/\n}\n\n@media only screen and (max-width: 767px) {\n  .sectionright {\n    float: unset !important;\n  }\n\n  .dashboard {\n    padding: 10px 10px !important;\n  }\n}\n\n@media only screen and (max-width: 600px) {\n  .cont2 {\n    width: $dashwidth !important;\n    left: $dashleft !important;\n    position: relative !important;\n    padding: 10px 10px 15px !important;\n  }\n\n  .bodythemelight,\n  .bodythemedark {\n    padding-top: 110px;\n  }\n\n  .delPopContainer .modal-content {\n    min-width: 100%;\n  }\n\n  .delPopContainer .modal-body {\n    padding: 15px;\n  }\n\n  .larg_model .modal-content {\n    border-radius: 20px !important;\n    padding: 22px;\n  }\n}\n\n@media (min-width: 576px) {\n  .exer_modal_contain .modal-dialog {\n    max-width: 1055px;\n  }\n\n  .delPopContainer .modal-dialog {\n    max-width: 350px;\n  }\n\n  /*.tableheadlight th {\n    min-width: 120px;\n  } */\n}\n\n/* vk new changes */\n.active_show_outer {\n\n  h2 {\n    color: var(--Font-black, #0B0D0F);\n    font-family: Urbanist;\n    font-size: 22px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n    @media screen and (max-width:768px) {\n      margin-top: 15px;\n    }\n  }\n\n  .active_show_inner {\n    width: 100%;\n    display: block;\n\n    .act_box_img {\n      margin-bottom: 12px;\n      min-height: 400px;\n      object-fit: cover;\n      overflow: hidden;\n      height: 400px;\n      max-height: 400px;\n      @media (max-width: 767px) {\n        min-height: 300px;\n        height: 300px;\n        max-height: 300px;\n      }\n      img {\n        max-height: 400px;\n        /* align-self: stretch; */\n        width: 100%;\n        height: 100%;\n        border-radius: 12px;\n        object-fit: cover;\n      }\n    }\n\n    .act_box_cnt {\n      width: 100%;\n      display: block;\nsvg{\n  flex-shrink: 0;\n}\n      .act_box_bdg {\n        width: 100%;\n        margin-bottom: 12px;\n\n        span {\n          background: url(../../assets/ongoing.png) right top no-repeat;\n          width: 111px;\n          display: block;\n          height: 34px;\n          color: var(--White, #FFF);\n          font-size: 18px;\n          font-style: normal;\n          font-weight: 500;\n          padding: 3px 8px;\n        }\n\n        .sold {\n          background: url(../../assets/sold.png) right top no-repeat !important;\n        }\n\n      }\n\n      h3 {\n        color: var(--Secondary, #132941);\n        font-size: 18px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 26.304px;\n        margin: 0;\n      }\n\n      p {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        margin-bottom: 5px;\n\n        span {\n          color: var(--Light-1, #736B66);\n          font-size: 14px;\n          font-style: normal;\n          font-weight: 500;\n          line-height: 26.304px;\n        }\n\n        .timezone_code_pill {\n          display: inline-block;\n          padding: 2px 8px;\n          margin-left: 4px;\n          background: #e0f2fe;\n          color: #0369a1;\n          font-size: 12px;\n          font-weight: 600;\n          letter-spacing: 0.02em;\n          border-radius: 6px;\n        }\n      }\n    }\n  }\n}\n\n/* vk new changes */\n#attent_details_row1{\n    margin-bottom: 0 !important;\n}\n.attent_details {\n  .attent_details_inner {\n    display: flex;\n    gap: 61px;\n    padding: 20px;\n    border-radius: 5px;\n    background: #FFF;\n    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);\n    align-items: center;\n\n    @media (max-width: 576px) {\n      display: block !important;\n    }\n\n    @media (max-width: 992px) {\n      display: flex;\n      gap: 20px;\n      align-items: start;\n    }\n\n    .attent_details_inner_l {\n      img {\n        width: 187px;\n        height: 207px;\n        flex-shrink: 0;\n        object-fit: cover;\n      }\n    }\n\n    .attent_details_inner_r {\n      flex: 1;\n\n      .attent_details_row {\n        display: flex;\n        gap: 20px;\n        margin-bottom: 28px;\n\n        @media (max-width: 992px) {\n          margin-bottom: 0px;\n          display: inline-block;\n          width: 100%;\n        }\n\n        .attent_details_row_box {\n          flex: 1;\n          width: 22%;\n\n          @media (max-width: 576px) {\n            margin: 15px 0px 10px !important;\n            width: 100% !important;\n          }\n\n          @media (max-width: 992px) {\n            margin-bottom: 15px;\n            float: left;\n            margin-right: 0;\n            width: 50%;\n            padding-right: 10px;\n          }\n\n          p {\n            margin-bottom: 10px;\n            color: #727272;\n            font-size: 13px;\n            font-style: normal;\n            font-weight: 600;\n            line-height: normal;\n          }\n\n          h5 {\n            color: #131F43;\n            font-size: 16px;\n            font-style: normal;\n            font-weight: 600;\n            line-height: normal;\n            word-wrap: break-word;\n          }\n        }\n      }\n\n      .attent_details_row_last {\n        margin-bottom: 0px !important;\n        &.interesting_fact {\n          padding-top: 30px;\n          .attent_details_row_box {\n            width: 100%;\n            h5 {\n              color: #131F43;\n              font-size: 16px;\n              font-style: normal;\n              font-weight: 500;\n              line-height: 24px;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n .showbox_sec{\n      display: flex;\n    justify-content: flex-start;\n    gap: 0;\n    flex-direction: row;\n    flex-wrap: wrap;\n    @media screen and (max-width:500px) {\n      justify-content: center;\n    }\n }\n.show_box_main {\n  margin: 10px 0px;\n\n  .show_box {\n    min-height: 600px;\n    width: 300px;\n    float: left;\n    margin-right: 20px;\n    margin-bottom: 20px;\n    cursor: pointer;\n\n    @media (max-width: 1024px) {\n      margin-right: 18px;\n    }\n    @media (max-width: 767px) {\n      min-height: 500px;\n      width: 200px !important;\n    }\n\n    img {\n      max-height: 400px;\n      height: 100%;\n      width: 100%;\n\n      @media (max-width: 767px) {\n        max-height: 300px !important;\n      }\n    }\n\n    &:last-child {\n      margin-right: 0px !important;\n    }\n  }\n\n  .no_show_box {\n    width: 350px;\n    margin: 0 auto 20px;\n    display: block;\n  \n    @media (max-width: 767px) {\n      width: 250px !important;\n    }\n  \n    img {\n      max-height: 450px;\n      height: 100%;\n      width: 100%;\n  \n      @media (max-width: 767px) {\n        max-height: 350px !important;\n      }\n    }\n    h6 {\n      color: #000;\n      text-align: center;\n      font-size: 26px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: normal;\n      margin-top: 20px;\n      @media only screen and (max-width: 600px) {\n        font-size: 20px;\n      }\n    }\n  }\n  \n\n}\n\n.attent_flex {\n  justify-content: space-between !important;\n  gap: 30px;\n  align-items: center;\n\n  h5 {\n    font-size: 22px;\n    font-style: normal;\n    font-weight: 700;\n  }\n}","@import \"/src/styles/Variables/Variables.scss\";\n\n\n#container {\n  padding: 0px;\n  h5{\n    margin-top: 15px;\n  }\n}\n\n#tableheading {\n  font-size: 16px;\n  margin-top: 20px;\n}\n\n.search_box {\n  position: relative;\n}\n\n\n#spinner {\n  float: right;\n  margin-top: -25px;\n  position: relative;\n  z-index: 1;\n  margin-right: 10px;\n  cursor: pointer;\n  color: $primary-btncolor;\n}\n\n.tbl_sl {\n  min-width: 10px !important;\n}\n\n.tablebtn {\n  width: 70px;\n  padding: 6px;\n  border: none;\n  background-color: $primary-btncolor;\n  border-radius: 5px;\n  color: $white-color;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  font-size: 14px;\n\n  &:hover {\n    background-color: $secondary-btncolor;\n  }\n}\n\n.activeEventCard {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  background-color: #f9f9f9;\n  border-radius: 8px;\n  width: 500px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  margin-bottom: 50px;\n  margin-top: 20px;\n  cursor: pointer;\n  @media screen and (max-width:768px) {\n    width: 100%;\n    object-fit: contain;\n      align-items: center !important;\n      padding: 0 5px;\n\n  }\n}\n\n.eventImage {\n  width: 460px;\n  height: 250px;\n  object-fit: cover;\n  margin: 20px;\n  border-radius: 5px;\n  @media screen and (max-width:768px) {\n    width: 100% !important;\n    object-fit: contain;\n  }\n}\n\n.eventDetails {\n  padding: 0 15px;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  @media screen and (max-width:768px) {\n      padding: 0 15px 15px 15px;\n\n  }\n}\n\n.eventTitle {\n  font-size: 18px;\n  font-weight: bold;\n  margin: 0;\n  color: #131F43;\n}\n\n.eventDescription {\n  color: #727272;\n\nfont-size: 14px;\nfont-style: normal;\nfont-weight: 600;\n  margin-top: 15px;\n}\n.eventDescription1 {\n  color: #727272;\n\nfont-size: 14px;\nfont-style: normal;\nfont-weight: 500;\n  margin-top: 15px;\n}\n\ntable {\n  border-collapse: separate !important;\n  border-spacing: 0 6px !important;\n}\n\n// Set border-radius on the top-left and bottom-left of the first table data on the table row\ntd:first-child,\nth:first-child {\n  border-radius: 8px 0 0 8px;\n}\n\n// Set border-radius on the top-right and bottom-right of the last table data on the table row\ntd:last-child,\nth:last-child {\n  border-radius: 0 8px 8px 0;\n}\n\n.tableheaddiv {\n  display: flex;\n}\n\nth,\ntd {\n  font-size: 15px;\n}\n\n.tableheading {\n  padding: 0.8rem 1rem !important;\n  min-width: 150px !important;\n}\n\ntd {\n  padding: .5rem 0.5rem !important;\n  line-height: 15px;\n}\n\n\n\n// .order_date{\n//     margin-top: 5px;\n//     font-size: 12px;\n//     color: #898989;\n//     font-weight: normal;\n//   }\n\n.sortbtn {\n  border: none;\n  background: none;\n  color: #6E6E6E;\n}\n\n.order_date {\n  margin-top: 5px;\n  font-size: 12px;\n  color: #000;\n  font-weight: normal;\n}\n\nh6 {\n  color: #000;\n}\n\n\n.norecord {\n  font-size: 22px;\n  margin-top: 10px;\n  color: #939090;\n}\n.norecordsdiv{\n  position: absolute;\n  left: 42%;\n  margin-top: 2%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.sectionright {\n  float: right;\n  display: flex;\n\n  #dropdown {\n    margin: 0px 10px 10px 10px;\n  }\n\n  #dropdown button {\n    background-color: $primary-btncolor;\n    border-radius: 5px;\n    border: none;\n    box-shadow: none;\n    font-size: 14px;\n    min-width: 140px;\n    min-height: 44px;\n  }\n\n  a {\n    font-size: 14px;\n\n  }\n\n  #del_icon {\n    font-size: 12px;\n    margin-left: 5px;\n  }\n\n}\n\n.no_evnt {\n  text-align: center;\n  margin: 1.5%;\n\n  img {\n    max-width: 374px;\n    @media only screen and (max-width: 600px) {\n      max-width: 250px;\n    }\n  }\n\n  h6 {\n    color: #000;\n    text-align: center;\n    font-size: 26px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n    margin-top: 20px;\n    @media only screen and (max-width: 600px) {\n      font-size: 20px;\n    }\n  }\n\n  button {\n    padding: 2px 20px;\n    margin-top: 20px;\n  }\n}\n\n@media only screen and (max-width: 600px) {\n  #dashboardcont2 {\n    width: $dashwidth;\n    left: $dashleft;\n    position: relative;\n    padding: $dashboardpadding;\n  }\n}\n\ntr:nth-child(even) {\n  background-color: #fcfcfc;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `EventCustomTable_dashboard__3q6ll`,
	"dashboardContain": `EventCustomTable_dashboardContain__XQ+IO`,
	"bodythemedark": `EventCustomTable_bodythemedark__qLtQS`,
	"cont2": `EventCustomTable_cont2__Brv3d`,
	"top_header": `EventCustomTable_top_header__gBuaB`,
	"top_header_inner": `EventCustomTable_top_header_inner__Srb3z`,
	"subLink": `EventCustomTable_subLink__mXaME`,
	"cst_vendr": `EventCustomTable_cst_vendr__4-B7R`,
	"form-control": `EventCustomTable_form-control__OVMIQ`,
	"footer": `EventCustomTable_footer__d3Hdv`,
	"bodythemelight": `EventCustomTable_bodythemelight__DjJjM`,
	"bodythemeNew": `EventCustomTable_bodythemeNew__Mx1tO`,
	"headerthemelight": `EventCustomTable_headerthemelight__-F6ud`,
	"headerthemedark": `EventCustomTable_headerthemedark__k1vRs`,
	"menuthemelight": `EventCustomTable_menuthemelight__iXOHs`,
	"menuthemedark": `EventCustomTable_menuthemedark__05uNh`,
	"menulinklight": `EventCustomTable_menulinklight__yRckC`,
	"menulinkdarkSelected": `EventCustomTable_menulinkdarkSelected__FteB6`,
	"menulinklightSelected": `EventCustomTable_menulinklightSelected__U8a5W`,
	"menulinkdark": `EventCustomTable_menulinkdark__p4O4v`,
	"sub_arrow": `EventCustomTable_sub_arrow__ZGx5+`,
	"headinglight": `EventCustomTable_headinglight__yr13r`,
	"headingdark": `EventCustomTable_headingdark__0WCp8`,
	"searchboxlight": `EventCustomTable_searchboxlight__7KGVy`,
	"searchboxdark": `EventCustomTable_searchboxdark__N4Jdf`,
	"tableheadlight": `EventCustomTable_tableheadlight__WYBfi`,
	"tableheaddark": `EventCustomTable_tableheaddark__8fZUF`,
	"table": `EventCustomTable_table__D4D3z`,
	"table-borderless": `EventCustomTable_table-borderless__W3epF`,
	"left-section": `EventCustomTable_left-section__EJ9TT`,
	"tablebodylight": `EventCustomTable_tablebodylight__KU-2a`,
	"tablebodydark": `EventCustomTable_tablebodydark__pGqng`,
	"paginationlight": `EventCustomTable_paginationlight__ela15`,
	"paginationdark": `EventCustomTable_paginationdark__VhRt0`,
	"formthemelight": `EventCustomTable_formthemelight__jFUCP`,
	"formthemedark": `EventCustomTable_formthemedark__pMIn4`,
	"viewformlight": `EventCustomTable_viewformlight__iogzo`,
	"permissionboxlight": `EventCustomTable_permissionboxlight__dq1JN`,
	"permissionboxdark": `EventCustomTable_permissionboxdark__X-qMv`,
	"errormsgclr": `EventCustomTable_errormsgclr__HsOHG`,
	"graphclrlight": `EventCustomTable_graphclrlight__DdTSP`,
	"graphclrdark": `EventCustomTable_graphclrdark__ns0wM`,
	"card1bglight": `EventCustomTable_card1bglight__sy6pB`,
	"card1bgdark": `EventCustomTable_card1bgdark__p5W0d`,
	"card2bglight": `EventCustomTable_card2bglight__GwGNN`,
	"card2bgdark": `EventCustomTable_card2bgdark__i3MmW`,
	"card3bglight": `EventCustomTable_card3bglight__fB6cC`,
	"card3bgdark": `EventCustomTable_card3bgdark__l6dKJ`,
	"card4bglight": `EventCustomTable_card4bglight__yjmoi`,
	"card4bgdark": `EventCustomTable_card4bgdark__hOgkz`,
	"actionbtnlight": `EventCustomTable_actionbtnlight__GMAzQ`,
	"actionbtndark": `EventCustomTable_actionbtndark__Q-Xp4`,
	"profiledropdownlight": `EventCustomTable_profiledropdownlight__yn+M0`,
	"profiledropdowndark": `EventCustomTable_profiledropdowndark__U-c+v`,
	"settingsection": `EventCustomTable_settingsection__BRb8e`,
	"addform": `EventCustomTable_addform__EvGbn`,
	"savebtn": `EventCustomTable_savebtn__64s4O`,
	"profile_conatiner": `EventCustomTable_profile_conatiner__k-685`,
	"ag-theme-alpine": `EventCustomTable_ag-theme-alpine__IEojh`,
	"ag-row": `EventCustomTable_ag-row__TZELq`,
	"formbtn": `EventCustomTable_formbtn__SUWQ4`,
	"resetbtn": `EventCustomTable_resetbtn__9b4+x`,
	"addBtn": `EventCustomTable_addBtn__9RhtQ`,
	"addDltBtn": `EventCustomTable_addDltBtn__t-Q7H`,
	"addbtnlight": `EventCustomTable_addbtnlight__eTlom`,
	"addbtndark": `EventCustomTable_addbtndark__bMr9E`,
	"cust_addBtn": `EventCustomTable_cust_addBtn__vv9eT`,
	"deleteBtn": `EventCustomTable_deleteBtn__E3Fhe`,
	"confirmBtn": `EventCustomTable_confirmBtn__I7fCu`,
	"delPopContainer": `EventCustomTable_delPopContainer__95uSG`,
	"modal-body": `EventCustomTable_modal-body__U1PVI`,
	"delet_icon": `EventCustomTable_delet_icon__irRuE`,
	"arrowback": `EventCustomTable_arrowback__sweN4`,
	"drpdwn_btn": `EventCustomTable_drpdwn_btn__9Lm0-`,
	"empname": `EventCustomTable_empname__MlIqa`,
	"navitemli": `EventCustomTable_navitemli__3wEvf`,
	"tabnavli": `EventCustomTable_tabnavli__i6PCO`,
	"settingsgeneral": `EventCustomTable_settingsgeneral__ckofZ`,
	"settingslinks": `EventCustomTable_settingslinks__kqyuO`,
	"dropdown_menu_contain": `EventCustomTable_dropdown_menu_contain__jxRe4`,
	"dropdown_item": `EventCustomTable_dropdown_item__m3Nvq`,
	"profile_arrrow_dwn": `EventCustomTable_profile_arrrow_dwn__sVo-X`,
	"dateinputbox1": `EventCustomTable_dateinputbox1__gNe5E`,
	"modal-content": `EventCustomTable_modal-content__JLLTS`,
	"larg_model": `EventCustomTable_larg_model__pWOWj`,
	"modal-dialog": `EventCustomTable_modal-dialog__1wYP+`,
	"modal-header": `EventCustomTable_modal-header__v-3Bv`,
	"btn-primary": `EventCustomTable_btn-primary__bWb5o`,
	"form-select": `EventCustomTable_form-select__HWcjy`,
	"CustomTable_tableheadlight__HuHZw": `EventCustomTable_CustomTable_tableheadlight__HuHZw__qFUJW`,
	"CustomTable_tableheaddark__nwqb4": `EventCustomTable_CustomTable_tableheaddark__nwqb4__0h5ze`,
	"sectionright": `EventCustomTable_sectionright__M78q0`,
	"exer_modal_contain": `EventCustomTable_exer_modal_contain__wLPOn`,
	"active_show_outer": `EventCustomTable_active_show_outer__KPVlb`,
	"active_show_inner": `EventCustomTable_active_show_inner__vZMzv`,
	"act_box_img": `EventCustomTable_act_box_img__goHjk`,
	"act_box_cnt": `EventCustomTable_act_box_cnt__uIHod`,
	"act_box_bdg": `EventCustomTable_act_box_bdg__UMXBl`,
	"sold": `EventCustomTable_sold__Da1aU`,
	"timezone_code_pill": `EventCustomTable_timezone_code_pill__jkDkG`,
	"attent_details_row1": `EventCustomTable_attent_details_row1__xGhlL`,
	"attent_details": `EventCustomTable_attent_details__VXDMx`,
	"attent_details_inner": `EventCustomTable_attent_details_inner__5XlhJ`,
	"attent_details_inner_l": `EventCustomTable_attent_details_inner_l__U6LHL`,
	"attent_details_inner_r": `EventCustomTable_attent_details_inner_r__+kMap`,
	"attent_details_row": `EventCustomTable_attent_details_row__WnSeV`,
	"attent_details_row_box": `EventCustomTable_attent_details_row_box__a3QTl`,
	"attent_details_row_last": `EventCustomTable_attent_details_row_last__OcVmB`,
	"interesting_fact": `EventCustomTable_interesting_fact__jFW2Y`,
	"showbox_sec": `EventCustomTable_showbox_sec__8vZvr`,
	"show_box_main": `EventCustomTable_show_box_main__9Cocn`,
	"show_box": `EventCustomTable_show_box__opAYs`,
	"no_show_box": `EventCustomTable_no_show_box__uTi8N`,
	"attent_flex": `EventCustomTable_attent_flex__WYsFd`,
	"container": `EventCustomTable_container__ZqObS`,
	"tableheading": `EventCustomTable_tableheading__ePGAx`,
	"search_box": `EventCustomTable_search_box__0l2fh`,
	"spinner": `EventCustomTable_spinner__qqFq6`,
	"tbl_sl": `EventCustomTable_tbl_sl__CiOby`,
	"tablebtn": `EventCustomTable_tablebtn__2Qu81`,
	"activeEventCard": `EventCustomTable_activeEventCard__RgCH2`,
	"eventImage": `EventCustomTable_eventImage__HV7v7`,
	"eventDetails": `EventCustomTable_eventDetails__qM9o0`,
	"eventTitle": `EventCustomTable_eventTitle__7fG9k`,
	"eventDescription": `EventCustomTable_eventDescription__OCusY`,
	"eventDescription1": `EventCustomTable_eventDescription1__IaIJ5`,
	"tableheaddiv": `EventCustomTable_tableheaddiv__4JF3z`,
	"sortbtn": `EventCustomTable_sortbtn__ARt-g`,
	"order_date": `EventCustomTable_order_date__ixecV`,
	"norecord": `EventCustomTable_norecord__iOTnW`,
	"norecordsdiv": `EventCustomTable_norecordsdiv__zyUIh`,
	"dropdown": `EventCustomTable_dropdown__vscmA`,
	"del_icon": `EventCustomTable_del_icon__almwv`,
	"no_evnt": `EventCustomTable_no_evnt__H6cQu`,
	"dashboardcont2": `EventCustomTable_dashboardcont2__lDu7a`
};
export default ___CSS_LOADER_EXPORT___;
